<div class="monthly-giving-wrapper">
  <div class="main-title" [innerHTML]="info.mainTitle">
  </div>
  <div class="desc">{{info.desc}}</div>

  <div class="contents">
    <div class="box-item box-item-{{i}}" *ngFor="let box of info.boxes; index as i">
      <img [attr.data-src]="'/assets/images/thank-you/ellipse-3.png'" class="ellipse-bg-img-main" alt="ellipse box 1" loading="lazy" [class.rotate-54]="i==1" alt="ellipse img 1 box 1">
      <img [attr.data-src]="'/assets/images/thank-you/ellipse-4.png'" class="ellipse-bg-img-small" [class.first-oval]="i===1" alt="ellipse box 2" *ngIf="i>=1" loading="lazy" />
      <div class="title">{{box.title}}</div>
      <div class="img-wrapper">
        <img loading="lazy" [attr.data-src]="'/assets/images/thank-you/' + box.imgName + '.png'" alt="box image" />
      </div>
    </div>
  </div>
  <div class="action">
    <div class="button-wrapper thankyou-btn" *ngIf="!platform">
      <a target="_blank" *ngIf="!isMobile" [href]="util.isAppleDevice() ? vars.appLink.iOS : vars.appLink.android" (click)="systemEventHandler('downloadApp')">
        <app-button iconName="get_app" label="Download Ketto SIP App" btnClass="primary-button full-width"></app-button>
      </a>
      <a target="_blank" *ngIf="isMobile" href="https://sipketto.page.link/4Mnz" (click)="systemEventHandler('downloadApp')">
        <app-button iconName="get_app" label="Download Ketto SIP App" btnClass="primary-button full-width"></app-button>
      </a>
    </div>
    <a class="login-wrapper cursor-pointer" routerLink="/" (click)="systemEventHandler(isLoggedIn?'continue':'login')">
      {{isLoggedIn ? 'Continue':'Login to SIP'}} {{platform && platform.match('android|ios') ? 'in app': 'on browser'}} <mat-icon>arrow_forward</mat-icon>
    </a>
  </div>
</div>